// extracted by mini-css-extract-plugin
export default {"popupContent":"DeprecatedTooltip_popupContent__hRQfc"};